import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/site/Home";
import AdminApplications from "@/pages/AdminApplications";
import AdminCuriosity from "@/pages/AdminCuriosity";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Terms from "@/pages/Terms";
import Workshop from "@/pages/Workshop";
import DolceVitaAudit from "@/pages/DolceVitaAudit";
import PriorityList from "@/pages/PriorityList";

function App() {
  return (
    <div className="grain">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Navigate to="/priority" replace />} />
          <Route path="/admin/applications" element={<AdminApplications />} />
          <Route path="/admin/curiosity" element={<AdminCuriosity />} />
          <Route path="/reserve" element={<Navigate to="/priority" replace />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/dolce-vita-audit" element={<DolceVitaAudit />} />
          <Route path="/priority" element={<PriorityList />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
